export enum GpsEventType {
  NONE = 'NONE',
  DRIVER_IN_COUNTRY = 'DRIVER_IN_COUNTRY',
  VEHICLE_IN_COUNTRY = 'VEHICLE_IN_COUNTRY',
  DRIVER_CROSSING_BORDER = 'DRIVER_CROSSING_BORDER',
  VEHICLE_CROSSING_BORDER = 'VEHICLE_CROSSING_BORDER',
  DRIVER_IN_COUNTRY_PROGRESS = 'DRIVER_IN_COUNTRY_PROGRESS',
  VEHICLE_IN_COUNTRY_PROGRESS = 'VEHICLE_IN_COUNTRY_PROGRESS',
}
